module.exports = __webpack_public_path__ + "img/05.edc20940.jpg";